import { View, Text, StyleSheet } from 'react-native'
import InputText from '../InputText'
import { useEffect, useState } from 'react'
import DropdownNative from '../MultiSelectNative/MultiSelect'
import useDimensions from '../../../hooks/useDimensions'
import { IProject } from '../../../interfaces/project.interface'
import ColorPickerNative from '../ColorPicker'
import { getStyleSheet } from '../../../assets/theme/styles'
import { ProjectService } from '../../../services/ProjectService'
import { StatusProject } from '../../../models'
import { useToast } from 'react-native-toast-notifications'

const Settings = ({
    project,
    clients,
    groups,
    setProjectName,
}: {
    project: IProject
    clients: any
    groups: any
    setProjectName: (name: string) => void
}) => {
    const [valueName, setValueName] = useState('')
    const [valueColor, setValueColor] = useState('')
    const { windowWidth } = useDimensions()
    const globalStyles = getStyleSheet()
    const toast = useToast()

    useEffect(() => {
        setValueName(project.name)
        setProjectName(project.name)
        setValueColor(project.groupcolor)
    }, [project])

    const onUpdateProject = async (newObject: any = null) => {
        ProjectService()
            .updateProjectById(newObject)
            .then(() => {
                toast.show('Project was updated successfully', {
                    type: 'success',
                })
            })
            .catch(() => {})
    }

    const onHandleChangeColor = (color: string, objectId: string, version: number) => {
        const objectUpdate = {
            id: objectId,
            groupcolor: color.replace('#', ''),
            _version: version,
        }
        if (project.groupcolor === color.replace('#', '')) return
        onUpdateProject(objectUpdate)
        setValueColor(color.replace('#', ''))
    }

    const onHandleChangeGroup = (group: any, projectId: string, version: number) => {
        const objectUpdate = {
            id: projectId,
            groupID: group,
            _version: version,
        }

        onUpdateProject(objectUpdate)
    }

    const onHandleChangeClient = (client: any, projectId: string, version: number) => {
        const objectUpdate = {
            id: projectId,
            clientID: client,
            _version: version,
        }

        onUpdateProject(objectUpdate)
    }

    const onCellEditComplete = async ({
        newValue,
        field,
        oldValue,
    }: {
        newValue: string
        field: string
        oldValue: string
    }) => {
        if (newValue.trim().length > 0) {
            if (newValue.trim() !== oldValue.trim()) {
                project[field] = newValue

                const objectUpdate = {
                    id: project['id'],
                    name: newValue,
                    _version: project['_version'],
                }
                await onUpdateProject(objectUpdate)
                setProjectName(newValue)
            }
        }
    }

    return (
        <View style={styles.container}>
            <View style={{ ...styles.labelContainer, width: windowWidth > 600 ? '40%' : '100%' }}>
                <Text style={{ ...styles.label, color: globalStyles.text }}>Name</Text>
                <InputText
                    containerStyle={{ flexGrow: 1 }}
                    value={valueName}
                    skeletonStyles={{ flexGrow: 1, width: 'auto' }}
                    onChange={e => {
                        setValueName(e.valueOf())
                    }}
                    onBlur={() => {
                        onCellEditComplete({
                            field: 'name',
                            newValue: valueName,
                            oldValue: project.name,
                        })
                    }}
                />
            </View>

            <View style={{ ...styles.labelContainer, width: windowWidth > 600 ? '40%' : '100%' }}>
                <Text style={{ ...styles.label, color: globalStyles.text }}>Client</Text>
                <DropdownNative
                    containerStyles={{
                        paddingRight: 5,
                        flexGrow: 0,
                        paddingLeft: windowWidth <= 600 ? 15 : 0,
                    }}
                    customStyles={[
                        windowWidth > 600 ? { paddingHorizontal: 4 } : null,
                        { borderColor: globalStyles.borderColor, borderWidth: 1 },
                    ]}
                    valueWhenUniqueSelection={project.clientID}
                    indentificator={`${project.id}-client`}
                    options={clients}
                    onChange={change => onHandleChangeClient(change, project.id, project._version)}
                    optionLabel="name"
                    optionValue="code"
                    placeholder="Client"
                    uniqueSelection
                    emptyFilterMessage="No Client added"
                    includeHovered
                />
            </View>

            <View style={{ ...styles.labelContainer, width: windowWidth > 600 ? '40%' : '100%' }}>
                <Text style={{ ...styles.label, color: globalStyles.text }}>Color</Text>
                <ColorPickerNative
                    customStyles={{ width: 36 }}
                    value={valueColor}
                    identificator={`${project.id}-color`}
                    loading={false}
                    skeletonStyles={{ width: 36 }}
                    onChange={color => onHandleChangeColor(color, project.id, project._version)}
                />
            </View>

            <View style={{ ...styles.labelContainer, width: windowWidth > 600 ? '40%' : '100%' }}>
                <Text style={{ ...styles.label, color: globalStyles.text }}>Group</Text>
                <DropdownNative
                    containerStyles={{
                        paddingLeft: 5,
                        flexGrow: 0,
                    }}
                    customStyles={[
                        windowWidth > 600 ? { paddingLeft: 4, paddingRight: 4 } : null,
                        { borderColor: globalStyles.borderColor, borderWidth: 1 },
                    ]}
                    valueWhenUniqueSelection={project.groupID}
                    indentificator={`${project.id}-group`}
                    options={groups}
                    onChange={change => onHandleChangeGroup(change, project.id, project._version)}
                    optionLabel="name"
                    optionValue="code"
                    placeholder="Group"
                    uniqueSelection
                    emptyFilterMessage="No groups added"
                    includeHovered
                />
            </View>
        </View>
    )
}

export default Settings

const styles = StyleSheet.create({
    container: {
        flex: 1,
        gap: 20,
    },
    labelContainer: {
        gap: 10,
    },
    label: {
        fontSize: 18,
        fontWeight: '600',
    },
})
